import React, { useEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { data } from "jquery";
import { orderBy } from "lodash";

interface ChartProps{
    id:string;
    header:string;
    data:any[];
    cumulativeFields:any[];
}

const CumulativeChart = (props:ChartProps) =>{

    let chart = useRef(null)
    am4core.options.autoDispose = true;

    const prepareData = () =>{
        let totals:any = {};
        props.cumulativeFields.forEach((obj)=>{
            const field = obj.field
            totals[field] = 0;
        })
        let arr:any = [];
        props.data.forEach((obj)=>{
            let newObj:any = {...obj}
            props.cumulativeFields.forEach((obj2)=>{
                const field = obj2.field
                totals[field] += obj[field]
                newObj[field] = totals[field]
            })
            arr.push(newObj)
        })
        arr = orderBy(arr,["date"],"asc")
        return arr;
    }

    useEffect(()=>{
        if(props.data != null && props.data.length > 0){
            chart.current = am4core.create("machine-times-cumulative-chart", am4charts.XYChart);
            createChart()
        }
        return function cleanup() {
            if (chart.current) {
                chart.current.dispose();
            }
        };
    },[props.data])

    const createChart = () =>{
        chart.current.data = prepareData();
        var dateAxis = chart.current.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 50;

        var valueAxis = chart.current.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Hours"
        
        chart.current.cursor = new am4charts.XYCursor();
        chart.current.cursor.behavior = "panX";
        chart.current.mouseWheelBehavior = "zoomX";

        props.cumulativeFields.forEach((obj)=>{
            createSeries(obj.field,obj.field,obj.color)
        })

        function createSeries(field:string, name:string, color:am4core.Color){
            // Create series
            let series = chart.current.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = field;
            series.name = name;
            //series.dataFields.dateX = "timestamp" + props.data[i].name;
            series.dataFields.dateX = "date"
            series.dataFields.valueX = field;
            series.strokeWidth = 2;
            series.minBulletDistance = 10;
            //series.tooltip.pointerOrientation = "vertical";
            series.tooltip.background.fillOpacity = 0.5;
            series.tooltip.label.padding(12,12,12,12)
            series.stacked = true;
            series.tooltipText = "{name}: [bold]{valueY}[/]";
            series.stroke = color;
            series.fill = color;

            series.tooltip.dy = -2;
            series.tooltip.label.paddingTop = 2;
            series.tooltip.label.paddingBottom = 2;
            series.tooltip.label.interactionsEnabled = true;

            series.stacked = true;
            //series.fill = seriesColor;
            series.fillOpacity = 0.7;

        }
    }

    return <div id="machine-times-cumulative-chart" style={{ width: "100%", height: "100%"}}></div>
}

export default CumulativeChart;
